export default {"src":"/_next/static/image/public/images/flags/flag_679.82c0a7262e2f1495f198cb350e62c5ac.svg","height":16,"width":24};